<template>
	<v-card
		class="text-center mx-auto"
		:max-width="maxWidth"
		:width="width"
		flat
	>
		<h3 class="text-h6 mb-4">Iдентифікація страхового випадку</h3>

		<div class="text-body-2">
			Вам було надіслано СМС від контакт-центру з реєстраційним номером страхового повідомлення.<br>
			<!-- Введіть, будь-ласка, номер страхового повідомлення, отриманий в СМС, та номер Вашого автомобіля -->
			 Введіть, будь-ласка, номер страхового повідомлення, отриманий в СМС, та номер Вашого телефону
		</div>

		<v-form ref="form">
			<v-row dense class="my-6">
				<v-col cols="12">
					<v-text-field
						v-model="claim.number"
						label="Номер страхового повідомлення"
						variant="outlined"
						maxlength="12"
						:rules="ClaimNumberRules"
						:disabled="identify"
						@input="claim.number = claim.number.toUpperCase()"
						@update:modelValue="item.changed=true"
						@keydown.ctrl.z="claim.number='P-04983'"
					></v-text-field>
				</v-col>
				<!-- <v-col cols="12" v-if="['auto'].includes(direction)">
					<v-text-field
						v-model="claim.vehicle.number"
						label="Номер автомобіля"
						variant="outlined"
						maxlength="12"
						:rules="[rules.required]"
						:disabled="identify"
						@input="claim.vehicle.number = claim.vehicle.number.toUpperCase()"
						@update:modelValue="item.changed=true"
						@keydown.ctrl.z="claim.vehicle.number='AA1234BB'"
						@keydown.ctrl.x="showDefault = !showDefault"
					></v-text-field>
				</v-col> -->
				<v-col cols="12">
					<v-text-field
						v-model="claim.applicant.phone"
						label="Номер телефону"
						variant="outlined"
						maxlength="10"
						prefix="+38"
						placeholder="ХХХХХХХХХХ"
						type="number"
						hide-spin-buttons
						:rules="[rules.required]"
						:disabled="identify"
						@update:modelValue="item.changed=true"
						@keydown.ctrl.z="claim.applicant.phone='0977760354'"
						@keydown.ctrl.x="showDefault = !showDefault"
					></v-text-field>
				</v-col>
			</v-row>
		</v-form>

		<v-btn v-if="!identify" width="50%" @click="onOk" class="my-3">OK</v-btn>

		<!-- <div v-if="!identify" class="text-caption my-6">
			Ви не отримали СМС? <a href="#" @click.prevent="claim.vehicle.number = ''">Resend</a>
		</div> -->
	</v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import mixin from './mixin/main'

export default {
	name: 'Component::Identification',
	mixins: [mixin],
	components: {

	},
	data: () => ({
		ClaimNumberLength: 5,

		identify: false //Ознака іденифікації
	}),
	computed: {
		...mapGetters(['ClaimNumber']),

		ClaimNumberRules() {
			return [
				v => !!v || this.$vuetify.locale.t('$vuetify.rule.required'),
				//v => (v && v.length == this.ClaimNumberLength) || 'Номер повідомлення не відповідає правилам розміру',
			]
		},

		direction() {
			return history.state?.direction ? history.state.direction : 'auto'
		},
	},

	created() {
		this.claim.number = this.ClaimNumber;
	},

	methods: {
		onOk() {
			var that = this

			//console.log(this.$options.name, 'onOk','refs', this.$refs)
			//console.log(this.$options.name, 'onOk','claim', this.claim)

			this.$refs.form.validate().then(({ valid: isValid }) => {
				//console.log(that.$options.name, 'onNext','isValid', isValid)
				
				if(isValid) {
					//console.log(this.$options.name, 'onNext','item', item)
					
					this.loading = true
					axios.post(`/claim/identification`, this.claim).then(response => {
						console.log(that.$options.name, 'onOk','response.data', response.data)

						that.setClaim(response.data)
						that.setStep(0)
					}, error => {
						console.log('error', error)
						
						if(error?.status == 404) error['errorMessage'] = 'Номер транспортного засобу не відповідає номеру, зареєстрованому в страховому повідомленні'
						
						this.showMessage(error)
					}).finally(() => {
						this.loading = false
					});
				}
			})
		},
	},
}
</script>
